var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"crumbs"},[_c('img',{attrs:{"src":require("@/assets/img/z-icon1.png")}}),_vm._v(" 当前所在位置："),_c('a',{attrs:{"href":"/"}},[_vm._v("旺点来")])])])
}]

export { render, staticRenderFns }